// popupnew.js
document.addEventListener('DOMContentLoaded', function() {
  // Esperar 0.5s tras el cargue completo del DOM
  setTimeout(() => {

    // Verificar si existe al menos un elemento con la clase .popupnew
    const popups = document.querySelectorAll('.popupnew');
    if (!popups.length) return; // Si no hay, no ejecuta nada

    // Inyectar estilos solo una vez
    if (!document.getElementById('popupnew-style')) {
      const style = document.createElement('style');
      style.id = 'popupnew-style';
      style.innerHTML = `
      .popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9998;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
      }
        image-with-text-overlay.image-with-text-overlay.text-center.section-spacing {
            display: block;
            width: 100%;
            position: initial;
            min-height: 100%;
            background: transparent;
        }
      .popup-overlay.active {
        opacity: 1;
        pointer-events: auto;
      }
      .popup-content {
        position: relative;
        background: white;
        padding: 0;
        width: 80%;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        z-index: 9999;
        animation: popIn 0.3s 
    ease forwards;
        height: 80vh;
      }
      @keyframes popIn {
        from { transform: scale(0.9); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
      .popup-close {
        position: absolute;
        right: 0;
        background: none;
        border: none;
        font-size: 22px;
        font-weight: bold;
        cursor: pointer;
        text-transform: uppercase;
        color: #333;
        z-index: 9;
        background: white;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    .row.grid.popupnew {
        padding: 0;
        margin: 0;
        height: 100%;
    }

    .row.grid.popupnew .small-12.columns {
        margin: 0;
        padding: 0;
        height: 100%;
        display: block !important;
    }

    .row.grid.popupnew image-with-text-overlay.image-with-text-overlay.text-center.mobile-height-500.desktop-height-650.section-spacing.section-spacing--disable-top.section-spacing--disable-bottom {
        display: block;
        width: 100%;
        position: initial;
        min-height: 100%;
    }
    `;
       document.head.appendChild(style);
    }

    // Crear los popups dinámicamente
    popups.forEach((popupElement) => {
      const overlay = document.createElement('div');
      overlay.classList.add('popup-overlay');

      const content = document.createElement('div');
      content.classList.add('popup-content');

      const closeBtn = document.createElement('button');
      closeBtn.classList.add('popup-close');
      closeBtn.innerHTML = '&times;';

      // Mover el contenido existente dentro del popup
      content.appendChild(closeBtn);
      content.appendChild(popupElement);
      overlay.appendChild(content);
      document.body.appendChild(overlay);

      // Mostrar popup (medio segundo después)
      setTimeout(() => overlay.classList.add('active'), 1500);

      // Cerrar popup con la X o clic fuera
      closeBtn.addEventListener('click', () => overlay.classList.remove('active'));
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) overlay.classList.remove('active');
      });
    });

  }, 2800);
});